import {Observable, Subscription} from 'rxjs';

import BufferingType  from '../Constants/BufferingType';
import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToBuffering = (
    buffering$: Observable<BufferingType>,
    playbackStore: IPlaybackStore
): Subscription =>
    buffering$
        .subscribe(bufferingType => {
            if (
                bufferingType !== BufferingType.NONE &&
                !playbackStore.value.isBuffering &&
                !playbackStore.value.isLoading
            ) {
                playbackStore.actions.buffer(bufferingType);
            } else if (bufferingType === BufferingType.NONE && !playbackStore.value.isPlaying) {
                playbackStore.actions.play();
            }
        });

export default subscribeToBuffering;